import _ from 'lodash';
import * as blueprint from '@adc/blueprint';
export const getAssetInfoLabel = (productInfo, eventType, listing, hideAuctionDate, hideAuctionType) => {
    if (blueprint.listing.utils.isSparkOffer(listing)) {
        return productInfo.label;
    }
    const listingStatusLabelValue = listing.listing_status_label;
    const listingStatusLabel = hideAuctionDate || !listingStatusLabelValue
        ? ''
        : `, ${listingStatusLabelValue}`;
    const listingAuctionTypeLabel = hideAuctionType
        ? ''
        : `, ${_.startCase(_.lowerCase(eventType))}`;
    return `${productInfo.label}${listingAuctionTypeLabel}${listingStatusLabel}`;
};
//# sourceMappingURL=utils.js.map